<template>
    <div class="details-container">  
        <div class="block-page-title row-flex">
            <h2>Your details</h2>
            <a :href="logout"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path d="M11.247 18.9729C10.61 18.3959 10.518 17.6829 11.326 17.2519C11.517 17.1499 11.988 17.1689 12.251 17.1709C13.805 17.1799 15.362 17.2279 16.912 17.3409C17.628 17.3929 17.886 17.0929 17.888 16.4629C17.892 15.5049 17.832 14.5469 17.86 13.5899C17.932 11.1119 18.05 8.63594 18.122 6.15794C18.157 4.96294 18.128 3.76694 18.128 2.54794C15.223 2.74594 11.022 2.94194 10.217 2.34894C9.90005 2.11594 9.65905 1.61594 9.80905 1.21394C10.311 0.617943 10.871 0.561943 11.499 0.466943C13.775 0.124943 16.094 0.199943 18.388 0.00694306C19.738 -0.107057 20.476 1.19694 20.429 2.87594C20.337 6.18894 20.379 9.50594 20.396 12.8209C20.403 14.2059 20.543 18.1809 20.485 18.7859C20.394 19.7289 19.649 20.1109 18.753 19.9559C17.779 19.7879 16.767 19.8449 15.774 19.7729C14.247 19.6609 11.814 19.5489 11.247 18.9729ZM0.499047 10.4089C0.479047 9.57594 1.09605 9.40594 1.69905 9.36294C3.52505 9.23294 5.35505 9.17294 7.18305 9.07694C7.52905 9.05894 7.87205 8.99694 8.30005 8.94494C7.78805 8.13294 7.31205 7.47994 6.96105 6.76594C6.83505 6.50894 6.80805 6.01394 7.06505 5.81294C7.59005 5.40294 7.97105 5.62094 8.19005 5.81894C9.60905 7.10194 11.023 8.40594 12.279 9.84194C12.717 10.4039 12.337 11.2399 12.102 11.6199C11.395 12.7639 10.162 13.4829 9.17705 14.3979C8.89005 14.6639 8.58005 14.9629 8.22505 15.0779C7.94505 15.1689 7.61005 15.2589 7.29105 14.9219C7.06805 14.6879 7.03705 14.1539 7.16205 13.8529C7.45405 13.1519 7.89105 12.5109 8.26905 11.8459C8.31305 11.7759 3.15005 11.8039 1.83505 11.5359C1.40605 11.4489 0.523047 11.4409 0.498047 10.4079L0.499047 10.4089Z" fill="#685BC7"/>
                </svg> Logout
            </a>
        </div>
    </div>
    <div class="details-bg-grey" id="block-details">
        <div class="details-container">
            <div class="block-delivery-data pt-6 bg-block">
                <div class="btn-close" v-if="editDetails" @click="closeForm">
                    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.77402 4.81604C10.1733 6.25299 11.5029 7.77259 13.0051 9.09354C13.7243 9.72574 14.7495 10.2274 15.5745 8.93549C15.9762 8.30474 16.5837 7.80449 17.1043 7.23609C17.1782 7.23609 17.2464 7.25639 17.3131 7.25494C17.3363 7.25494 17.3566 7.19984 17.3783 7.16939C17.2725 7.21144 17.1681 7.25494 17.0622 7.29699C19.0647 5.27279 21.0671 3.24859 23.071 1.22584C23.1754 1.12144 23.2755 0.966294 23.4016 0.935844C24.7414 0.615394 26.6511 -0.380756 27.3108 0.155744C28.6347 1.23019 27.5936 2.86434 26.6366 4.01129C24.3557 6.74164 22.1619 9.57929 19.6026 12.0283C18.2831 13.2913 18.2817 13.9307 19.4736 15.0081C20.0608 15.5388 20.5727 16.155 21.1179 16.7321L21.0903 16.6828C23.2044 18.6345 25.4142 20.4949 27.4051 22.5655C29.2495 24.4838 28.9783 25.5162 26.5931 27.3577L26.6743 27.3345C25.8884 27.0315 25.0053 26.8662 24.3369 26.3964C23.1537 25.5641 22.0488 24.5998 21.0077 23.5921C18.9762 21.6273 17.0115 19.5959 15.0221 17.5949C15.0018 17.6282 14.9771 17.6601 14.9525 17.692C15.0003 17.6688 15.0467 17.6442 15.0946 17.621C12.3628 20.7675 9.64112 23.9241 6.88757 27.0518C6.28002 27.742 5.65362 28.6163 4.86047 28.8846C4.12242 29.1354 2.64052 28.9672 2.38532 28.496C1.86187 27.5303 1.40367 25.899 1.87782 25.1494C2.98562 23.3992 4.66037 22.0072 6.10022 20.4673C6.13212 20.4746 6.16837 20.4833 6.20317 20.4934C6.17272 20.5152 6.14082 20.5355 6.11037 20.5572C6.12632 20.534 6.14227 20.5094 6.15822 20.4862C7.68217 18.3416 9.20467 16.1956 10.8997 13.8089C9.04517 12.0631 7.04707 10.2115 5.08522 8.32214C3.83387 7.11864 2.58832 5.90354 1.42832 4.61304C0.340822 3.40374 -0.0274783 2.00159 1.21807 0.687894C2.51002 -0.675105 3.53807 0.376144 4.55017 1.22874C5.81022 2.29159 7.08477 3.33559 8.35207 4.38684L8.33032 4.37524C8.22447 4.43034 8.75372 5.00454 8.78562 4.83489L8.77547 4.81459L8.77402 4.81604Z" fill="#685BC7"></path></svg>
                </div>
                <div class="row-data">
                    <div class="data-key"><strong>Full name</strong></div>
                    <transition name="fade">
                        <div class="data-value" v-if="!editDetails">{{ name ? name : ' - ' }}</div>
                    </transition>
                    <transition name="fade">
                        <div class="data-edit" v-if="editDetails">
                            <v-text-field 
                                name="name" 
                                label=""
                                type="text" 
                                v-model="name"
                                @keyup.enter="saveDetailsData"
                            >
                            </v-text-field>
                        </div>
                    </transition>
                </div>
                <div class="row-data">
                    <div class="data-key"><strong>Email address</strong></div>
                    <transition name="fade">
                        <div class="data-value" v-if="!editDetails">{{ email ? email : ' - ' }}</div>
                    </transition>
                    <transition name="fade">
                        <div class="data-edit" v-if="editDetails">
                            <v-text-field 
                                name="email" 
                                type="email" 
                                label=""
                                v-model="email"
                                @keyup.enter="saveDetailsData"
                            >
                            </v-text-field>
                        </div>
                    </transition>
                </div>
                <div class="row-data">
                    <div class="data-key"><strong>Phone number</strong></div>
                    <transition name="fade">
                        <div class="data-value" v-if="!editDetails">{{ phone ? phone : ' - ' }}</div>
                    </transition>
                    <transition name="fade">
                        <div class="data-edit" v-if="editDetails">
                            <v-text-field 
                                name="phone" 
                                type="number" 
                                label=""
                                v-model="phone"
                                @keyup.enter="saveDetailsData"
                            >
                            </v-text-field>
                        </div>
                    </transition>
                </div>
                <div class="row-data no-border">
                    <div class="data-key"><strong>Birthday</strong></div>
                    <transition name="fade">
                        <div class="data-value" v-if="!editDetails">{{ birthday ?  birthday : ' - ' }}</div>
                    </transition>
                    <transition name="fade">
                        <div class="data-edit row-flex" v-if="editDetails">
                            <v-text-field 
                                name="day" 
                                type="number" 
                                label="Day"
                                :max="31"
                                :min="1"
                                maxlength="2"
                                v-model="day"
                                @keyup="checkValue('day')"
                                @keyup.enter="saveDetailsData"
                                >
                                <span class="plus" @click="day < 31 ? day++ : 31"></span>
                                <span class="minus"  @click="day > 1 ? day-- : 1"></span>
                            </v-text-field>
                            <v-text-field 
                                name="month" 
                                :max="12"
                                :min="1"
                                type="number" 
                                label="Month"
                                maxlength="2"
                                v-model="month"
                                @keyup="checkValue('month')"
                                @keyup.enter="saveDetailsData"
                                >
                                <span class="plus" @click="month < 12 ? month++ : month"></span>
                                <span class="minus"  @click="month > 1 ? month-- : 1"></span>
                            </v-text-field>
                        </div>
                    </transition>
                </div>
                <div class="row-btn">
                    <div class="btn btn-edit-delivery" v-if="!editDetails" @click.prevent="editDetails = !editDetails">Edit account details <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path d="M16.052 20.508C14.677 19.157 12.133 16.359 10.792 14.974C10.17 14.331 9.55899 13.676 8.95999 13.012C8.54799 12.556 8.16899 12.379 7.45799 12.479C4.30899 12.923 2.08699 11.65 0.882992 8.99303C0.241992 7.57603 0.470992 6.22003 1.08799 4.91003C1.38899 4.27003 1.98799 4.59403 2.36999 4.87803C2.86599 5.24603 3.36099 5.67703 3.69999 6.18403C4.31299 7.10303 4.87299 6.99003 5.53599 6.29103C5.73799 6.07903 5.98899 5.91403 6.27399 5.68203C5.64599 4.88803 4.97499 4.16403 4.45899 3.34203C4.13499 2.82503 3.92199 2.16303 3.91999 1.56503C3.91999 1.38803 4.79199 1.10203 5.28399 1.04603C7.95899 0.739033 9.86799 1.90703 10.836 4.49403C11.178 5.40803 11.271 6.41303 11.548 7.35603C11.662 7.74603 11.898 8.14703 12.188 8.43003C13.676 9.88303 16.432 12.68 17.913 14.141C18.666 14.884 19.343 15.708 20.019 16.524C20.498 17.102 20.42 18.387 19.813 18.845C19.128 19.361 18.503 19.897 17.686 20.704C17.348 21.038 16.653 21.094 16.053 20.505L16.052 20.508Z"/>
                        </svg>
                    </div>
                    <div class="btn btn-edit-delivery" v-if="editDetails" @click.prevent="saveDetailsData">Save account details <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path d="M16.052 20.508C14.677 19.157 12.133 16.359 10.792 14.974C10.17 14.331 9.55899 13.676 8.95999 13.012C8.54799 12.556 8.16899 12.379 7.45799 12.479C4.30899 12.923 2.08699 11.65 0.882992 8.99303C0.241992 7.57603 0.470992 6.22003 1.08799 4.91003C1.38899 4.27003 1.98799 4.59403 2.36999 4.87803C2.86599 5.24603 3.36099 5.67703 3.69999 6.18403C4.31299 7.10303 4.87299 6.99003 5.53599 6.29103C5.73799 6.07903 5.98899 5.91403 6.27399 5.68203C5.64599 4.88803 4.97499 4.16403 4.45899 3.34203C4.13499 2.82503 3.92199 2.16303 3.91999 1.56503C3.91999 1.38803 4.79199 1.10203 5.28399 1.04603C7.95899 0.739033 9.86799 1.90703 10.836 4.49403C11.178 5.40803 11.271 6.41303 11.548 7.35603C11.662 7.74603 11.898 8.14703 12.188 8.43003C13.676 9.88303 16.432 12.68 17.913 14.141C18.666 14.884 19.343 15.708 20.019 16.524C20.498 17.102 20.42 18.387 19.813 18.845C19.128 19.361 18.503 19.897 17.686 20.704C17.348 21.038 16.653 21.094 16.053 20.505L16.052 20.508Z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

var monthTitle = ["January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"];

export default {
    name: 'Details-item',
    props: ['userDetails'],
    data() {
        return {            
            name: '',
            email: '',
            phone: '',
            birthday: '',
            day: '',
            month: '',           
            editDetails: false,
            logout: ''
        }
    },
    methods: {
        closeForm() {
            this.editDetails = false;
        },
        checkValue( label) {
            if ( 'day' == label && this.day > 31) {
                 this.day = '';
            }

            if ('month' == label && this.month > 12) {
                this.month = '';
            }
        },
        saveDetailsData() {
            this.editDetails = false;
            
            let name = this.name.split(' ');
            let user_birthday = {};
            
            if ( this.day ) {
                user_birthday.day = this.day;
            }

            if ( this.month ) {
                user_birthday.month = this.month;
            }

            let data = {
                first_name: name[0],
                billing_first_name: name[0],
                shipping_first_name: name[0],
                last_name: name[1],
                billing_last_name: name[1],
                shipping_last_name: name[1],
                email: this.email,
                shipping_phone: this.phone,
                billing_phone: this.phone,
                user_birthday: user_birthday
            }

            this.birthday = this.day;

            if ( monthTitle[(+this.month - 1)] ) {

                if (this.day) {
                    this.birthday += ' ';
                }

                this.birthday += monthTitle[(+this.month - 1)];
            }            

            this.loader = true;
            this.$store.dispatch('saveUserDetails', data);     
        }
    },
    computed: {
        loader() {
            return this.$store.getters.loader ?? false;
        },
    },
    async beforeMount() {
    },
    watch: {
        userDetails(newData) {
            if(newData.name) {
                this.name = newData.name;
            }

            if (newData.email) {
                this.email = newData.email;
            }

            if (newData.phone) {
                this.phone = newData.phone;
            }
            
            if (newData.day) {
                this.day = newData.day;
                this.birthday += newData.day + ' ';
            }

            if (newData.month) {
                this.month = newData.month;
                this.birthday += monthTitle[(+newData.month - 1)];
            }

            if (newData.logout) {
                this.logout = newData.logout;
            }           
        }
    }

}
</script >